import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Row } from "reactstrap";
import Button from "../../../../../components/Button";
import { useModal } from "../../../../../utils/hooks/useModal";
import { useUser } from "../../../../../utils/hooks/user";
import { useClockIn } from "../../store";

function ActionsRow({ children }) {
	return (
		<Row>
			<div className="col d-flex justify-content-between">{children}</div>
		</Row>
	);
}

const Actions = ({ loading }) => {
	const { t } = useTranslation();

	const [{ mode }, { setShiftAction }] = useClockIn();
	const user = useUser();

	const { open: openStartNewShiftModal, modal: startNewShiftModal } = useModal({
		head: (
			<h2 className="mb-0 text-center font-weight-bolder">
				{t("are-you-sure")}
			</h2>
		),
		icon: (
			<FontAwesomeIcon
				icon={faWarning}
				className="text-warning w-100 mb-5"
				fontSize={70}
			/>
		),
		message: t("start-new-shift-missed-punch-warning"),
		color: "warning",
		onConfirm: useCallback(() => {
			return setShiftAction("start-new-shift");
		}, [setShiftAction]),
	});

	const content = useMemo(() => {
		switch (mode) {
			case "shift": {
				return (
					<>
						<ActionsRow>
							<Button
								onClick={() => setShiftAction("start-break")}
								className="break-btn"
								hidden={
									!user?.calculationGroup?.breaks.manual.status
								}
								style={{ width: "33%" }}
								disabled={loading}
							>
								{t("take-break")}
							</Button>

							<Button
								onClick={() => setShiftAction("end-shift")}
								color="danger"
								className={classNames(
									"border-0",
									!user?.calculationGroup?.breaks.manual.status &&
									"w-50",
								)}
								style={{ width: "33%" }}
								disabled={loading}
							>
								{t("clock-out")}
							</Button>

							<Button
								onClick={() => setShiftAction("switch")}
								color="primary"
								className={classNames(
									"border-0",
									!user?.calculationGroup?.breaks.manual.status &&
									"w-50",
								)}
								style={{ width: "33%" }}
								disabled={loading}
							>
								{t("switch")}
							</Button>
						</ActionsRow>

						<Row className="mt-3">
							<div className="col">
								<Button
									className="w-100 bg-info border-0 text-white"
									onClick={() => openStartNewShiftModal()}
									disabled={loading}
								>
									{t("start-new-shift")}
								</Button>
							</div>
						</Row>
					</>
				);
			}
			case "break": {
				return (
					<>
						<ActionsRow>
							<Button
								className="w-100 break-btn"
								onClick={() => setShiftAction("end-break")}
								disabled={loading}
							>
								{t("end-break")}
							</Button>
						</ActionsRow>

						<Row className="mt-3">
							<div className="col">
								<Button
									className="w-100 bg-info border-0 text-white"
									onClick={() => openStartNewShiftModal()}
									disabled={loading}
								>
									{t("start-new-shift")}
								</Button>
							</div>
						</Row>
					</>
				);
			}
			case "end": {
				return (
					<ActionsRow>
						<Button
							className="w-100 bg-info border-0 text-white"
							onClick={() => setShiftAction("start-shift")}
							disabled={loading}
						>
							{t("start-new-shift")}
						</Button>
					</ActionsRow>
				);
			}
			default:
				return (
					<ActionsRow>
						<Button
							onClick={() => setShiftAction("start-break")}
							className="break-btn"
							hidden={
								!user?.calculationGroup?.breaks.manual.status
							}
							style={{ width: "33%" }}
							disabled={loading}
						>
							{t("take-break")}
						</Button>

						<Button
							onClick={() => setShiftAction("end-shift")}
							color="danger"
							className={classNames(
								"border-0",
								!user?.calculationGroup?.breaks.manual.status &&
								"w-50",
							)}
							style={{ width: "33%" }}
							disabled={loading}
						>
							{t("clock-out")}
						</Button>

						<Button
							color="primary"
							className={classNames(
								"border-0",
								!user?.calculationGroup?.breaks.manual.status &&
								"w-50",
							)}
							style={{ width: "33%" }}
							disabled={loading}
						>
							{t("switch")}
						</Button>
					</ActionsRow>
				);
		}
	}, [mode, t, user, setShiftAction, loading, openStartNewShiftModal]);

	return (
		<>
			{content}

			{startNewShiftModal}
		</>
	);
};

export default Actions;
